import Vue from 'vue'
import CoreChatClientComponent from './components/CoreChatClient'
import CoreChatClientTextLauncherComponent from './components/launchers/TextLauncher'
import CoreChatClientCircularLauncherComponent from './components/launchers/CircularLauncher'
import CoreChatClientPillLauncherComponent from './components/launchers/PillLauncher'
import vueCustomElement from 'vue-custom-element'
import ThemeUtil from './utils/ThemeUtil'
import StylesUtil from './utils/StylesUtil'
import EventUtil from './utils/EventUtil'
import './css/main.css'

Vue.prototype.$theme = new ThemeUtil()
Vue.prototype.$styles = new StylesUtil()

// Updating the prefix 'core-chat-client-' could break tracking, custom launchers, and custom events.
Vue.prototype.$events = new EventUtil('core-chat-client-')

Vue.use(vueCustomElement)
Vue.customElement('core-chat-client', CoreChatClientComponent)
Vue.customElement('core-chat-client-text-launcher', CoreChatClientTextLauncherComponent)
Vue.customElement('core-chat-client-circular-launcher', CoreChatClientCircularLauncherComponent)
Vue.customElement('core-chat-client-pill-launcher', CoreChatClientPillLauncherComponent)
